<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Prologue</a></li>
<li id="c01"><a href="#/c01">I</a>
</li>
<li id="c02"><a href="#/c02">II</a>
</li>
<li id="c03"><a href="#/c03">III</a>
</li>
<li id="c04"><a href="#/c04">IV</a>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">V</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">VI</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">VII</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">VIII</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">IX</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">X</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">XI</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">XII</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">XIII</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">XIV</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">XV</span>
</li>
<li id="c16"><span href="#/c16" title="Link target outside of Sample">XVI</span>
</li>
<li id="c17"><span href="#/c17" title="Link target outside of Sample">XVII</span>
</li>
<li id="c18"><span href="#/c18" title="Link target outside of Sample">XVIII</span>
</li>
<li id="c19"><span href="#/c19" title="Link target outside of Sample">XIX</span>
</li>
<li id="c20"><span href="#/c20" title="Link target outside of Sample">XX</span>
</li>
<li id="c21"><span href="#/c21" title="Link target outside of Sample">XXI</span>
</li>
<li id="c22"><span href="#/c22" title="Link target outside of Sample">XXII</span>
</li>
<li id="c23"><span href="#/c23" title="Link target outside of Sample">XXIII</span>
</li>
<li id="c24"><span href="#/c24" title="Link target outside of Sample">XXIV</span>
</li>
<li id="c25"><span href="#/c25" title="Link target outside of Sample">XXV</span>
</li>
<li id="c26"><span href="#/c26" title="Link target outside of Sample">XXVI</span>
</li>
<li id="c27"><span href="#/c27" title="Link target outside of Sample">XXVII</span>
</li>
<li id="c28"><span href="#/c28" title="Link target outside of Sample">XXVIII</span>
</li>
<li id="c29"><span href="#/c29" title="Link target outside of Sample">XXIX</span>
</li>
<li id="c30"><span href="#/c30" title="Link target outside of Sample">XXX</span>
</li>
<li id="c31"><span href="#/c31" title="Link target outside of Sample">XXXI</span>
</li>
<li id="c32"><span href="#/c32" title="Link target outside of Sample">XXXII</span>
</li>
<li id="c33"><span href="#/c33" title="Link target outside of Sample">XXXIII</span>
</li>
<li id="c34"><span href="#/c34" title="Link target outside of Sample">XXXIV</span>
</li>
<li id="c35"><span href="#/c35" title="Link target outside of Sample">XXXV</span>
</li>
<li id="c36"><span href="#/c36" title="Link target outside of Sample">XXXVI</span>
</li>
<li id="c37"><span href="#/c37" title="Link target outside of Sample">XXXVII</span>
</li>
<li id="c38"><span href="#/c38" title="Link target outside of Sample">XXXVIII</span>
</li>
<li id="c39"><span href="#/c39" title="Link target outside of Sample">XXXIX</span>
</li>
<li id="c40"><span href="#/c40" title="Link target outside of Sample">XL</span>
</li>
<li id="c41"><span href="#/c41" title="Link target outside of Sample">XLI</span>
</li>
<li id="c42"><span href="#/c42" title="Link target outside of Sample">XLII</span>
</li>
<li id="c43"><span href="#/c43" title="Link target outside of Sample">XLIII</span>
</li>
<li id="level1-back92"><span href="#/back01" title="Link target outside of Sample">Author's Note</span></li>
<li id="level1-back93"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></li>
<li id="level1-back94"><span href="#/back03" title="Link target outside of Sample">Sample Chapter from BEAUTIFUL LIES</span></li>
<li id="level1-back95"><span href="#/back04" title="Link target outside of Sample">Buy the Book</span></li>
<li id="level1-back96"><span href="#/back05" title="Link target outside of Sample">About the Author</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?f5237432